import { useEffect } from 'react';
import { antApi, hasAntApi } from './antd-provider';
import { useToastStore } from './toast-store';

/** Bridges the toast store to Ant's message API. Without the provider (unit tests) it renders a plain live region instead. */
export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  const markShown = useToastStore((s) => s.markShown);
  const bridged = hasAntApi();
  useEffect(() => {
    if (!bridged) return;
    for (const t of toasts) {
      if (t.shown) continue;
      markShown(t.id);
      antApi().message.open({ type: t.type, content: t.message, duration: t.ttlMs / 1000, key: String(t.id), onClose: () => dismiss(t.id) });
    }
  }, [toasts, dismiss, markShown, bridged]);
  if (bridged) return null;
  return (
    <div id="toast-container" aria-live="polite">
      {toasts.map((t) => <div key={t.id} className={`toast ${t.type} show`} role="status" onClick={() => dismiss(t.id)}>{t.message}</div>)}
    </div>
  );
}
